import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent, SvgElement } from '../../../shared/index.js';

import { IRectConfiguration, IRectProps, IRectState } from './models/index.js';
import { RECT_CATEGORY_KEY, RECT_COMPONENT_KEY } from './Rect.meta.js';

export class Rect extends SvgElement<IRectProps, IRectState, IRectConfiguration> {
	categoryKey = RECT_CATEGORY_KEY;
	componentKey = RECT_COMPONENT_KEY;

	constructor(props: IRectProps) {
		super(props);
	}
	render() {
		const { className, x = 0, y = 0, rx = 0, ry = 0 } = this.props;
		const svgProps = this.getElementSvgProps<SVGRectElement>({
			x,
			y,
			rx,
			ry,
		});
		return <rect className={className} {...svgProps} />;
	}
}

export default InjectedStyledComponent(observer(Rect), RECT_CATEGORY_KEY, RECT_COMPONENT_KEY);
